module.exports = __webpack_public_path__ + "static/assets/5610fba29744cce750f1da6c6091ecac.mp3";